import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Card, CardHeader, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton } from '@mui/material';
import axios from 'src/utils/axios';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Skeleton from '@mui/material/Skeleton';

const ReceiptStatusHistory = () => {
    const { ReceiptNumber } = useParams();
    const navigate = useNavigate();

    const [receiptStatusHistoryData, setReceiptStatusHistoryData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        getReceiptStatusHistoryInformation();
    }, [])

    const handleGoBack = () => {
        navigate(-1);
    };

    const getReceiptStatusHistoryInformation = () => {
        axios.get(`GetReceiptStatusHistoryInformation/${ReceiptNumber}`)
            .then((response) => {
                var data = response.data;
                setReceiptStatusHistoryData(Array.isArray(data) ? data : []);
                setPage(0);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Container maxWidth="md" sx={{ py: 3 }}>
            <Card>
                <CardHeader
                    avatar={
                        <IconButton onClick={() => { handleGoBack(); }} size="small">
                            <ArrowBackIcon />
                        </IconButton>
                    }
                    title="Fiş Durum Geçmişi"
                />
                <Divider />
                <TableContainer>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 700 }}>Fiş No</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Kullanıcı</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Durum</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>İşlem Tarihi</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                Array.from(new Array(3)).map((_, index) => (
                                    <TableRow key={index}>
                                        {Array.from(new Array(4)).map((_, cellIndex) => (
                                            <TableCell key={cellIndex} colSpan={1}>
                                                <Skeleton animation="pulse" variant="text" width={150} />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ) : (
                                receiptStatusHistoryData.length > 0 && receiptStatusHistoryData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((receipt, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{receipt.FIS_NO}</TableCell>
                                        <TableCell>{receipt.ADSOYAD}</TableCell>
                                        <TableCell>{receipt.ACIKLAMA}</TableCell>
                                        <TableCell>{moment(receipt.TARIH).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={receiptStatusHistoryData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Card>
        </Container>
    );
};

export default ReceiptStatusHistory;
